var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcNavi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.362 1.793a6.646 6.646 0 00-6.638 6.638 6.571 6.571 0 001.337 3.983s.18.238.21.273l5.09 6.003 5.093-6.006c.027-.032.208-.27.208-.27v-.002A6.569 6.569 0 0017 8.432a6.646 6.646 0 00-6.638-6.639zm0 9.052a2.413 2.413 0 110-4.827 2.413 2.413 0 010 4.827z",
    fill: "#191919"
  })));
}

export default SvgIcNavi;